// Az alsó SUM sor összegzéséből kizárandó sorok.
//
// Jelenleg CSAK a service_reservations nézetre vonatkozik: a lemondott (cancelled)
// service reservation értékei nem számítanak bele a szummákba.
// Cancelled SR = service_reservation_type.id === 4.
//
// Az activity_reservations / groups nézetek viselkedése szándékosan VÁLTOZATLAN
// (ott a szumma-cellák saját, meglévő szabályaik szerint szűrnek).
export const isRowExcludedFromSummary = (row: any, schema: any): boolean => {
  if (schema?.viewTable === 'service_reservations') {
    return row?.service_reservation_type?.id === 4;
  }

  return false;
};

export default isRowExcludedFromSummary;
